import { legacy_connect as connect } from 'react-redux';

import { AppState } from '../../../store/reducers/root';
import {
  getFirstPendingError,
  hasPendingErrors,
} from '../../../store/selectors/error';
import errorActions, {
  ErrorNotification as ErrorNotificationPayload,
} from '../../../store/slices/error';

import ErrorNotification from './ErrorNotification';

const EMPTY_ERROR: ErrorNotificationPayload = {
  id: null,
  name: '',
  code: null,
  message: '',
  stack: null,
  info: null,
  logout: false,
};

const mapStateToProps = (state: AppState) => {
  const error = getFirstPendingError(state) ?? EMPTY_ERROR;
  return {
    ...error,
    open: hasPendingErrors(state),
  };
};

const mapDispatchToProps = {
  onSubmit: errorActions.closeNotification,
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorNotification);
